import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Box,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppConfigRequest,
  getStoreListForUserRequest,
} from "../../redux/Dashboard/dashboardSlice";
import LogoImage from "../../Screenshot_4.png";
import { useAppTheme } from "../../theme/useAppTheme";

const SelectStoreDialog = ({ open, onClose, onSelect }) => {
  const dispatch = useDispatch();
  const { loading, storeList, appConfig } = useSelector(
    (state) => state.dashboard,
  );

  useEffect(() => {
    if (open) {
      dispatch(
        getStoreListForUserRequest({
          id: `${process.env.REACT_APP_JEWELLER_ID}`,
        }),
      );
      dispatch(getAppConfigRequest());
    }
  }, [open, dispatch]);

  const themeColors = useAppTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          background: themeColors.bigContainer,
          color: themeColors.text,
          border: `1px solid ${themeColors.scaffold}`,
          borderRadius: 3,
        },
      }}
    >
      {/* 🔹 Close Icon Added Here */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: themeColors.primary,
            width: "100%",
            textAlign: "center",
          }}
        >
          Select Store
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 12,
            background: themeColors.primary,
            color: themeColors.text,
            "&:hover": {
              background: themeColors.svgColor,
            },
            border: `1px solid ${themeColors.scaffold}`,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3, pt: 0 }}>
        {loading ? (
          <Box textAlign="center" py={5}>
            <CircularProgress color="secondary" />
            <Typography sx={{ mt: 2 }}>Loading stores...</Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            {storeList?.length > 0 ? (
              storeList.map((store) => (
                <Grid size={{ xs: 12, sm: 6 }} key={store._id}>
                  <Box
                    onClick={() => onSelect(store)}
                    sx={{
                      p: 2,
                      borderRadius: "12px",
                      cursor: "pointer",
                      background: themeColors.primary,
                      color: themeColors.text,
                      "&:hover": {
                        background: themeColors.svgColor,
                      },
                      border: `1px solid ${themeColors.scaffold}`,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <img
                        src={appConfig.logoUrl || LogoImage}
                        alt="store"
                        width={50}
                        height={50}
                        style={{
                          borderRadius: 12,
                          background: themeColors.primary,
                          border: `1px solid ${themeColors.scaffold}`,
                          padding: 6,
                        }}
                      />
                      <Box>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 700 }}
                        >
                          {store.branchName}
                        </Typography>
                        <Typography variant="body2">
                          {store.phone || "N/A"}
                        </Typography>
                        <Typography variant="body2">
                          Code: {store.branchCode || "-"}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        fontSize: "0.85rem",
                      }}
                    >
                      📍 {store.address1},{store.address2},{store.address3} -{" "}
                      {store.pincode}
                    </Typography>
                  </Box>
                </Grid>
              ))
            ) : (
              <Typography align="center" width="100%">
                No stores available
              </Typography>
            )}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SelectStoreDialog;
